define.alias("ember-power-select/components/power-select-multiple/input", "preview-grid/components/power-select-multiple/input");